import React, { useEffect, useState } from 'react';
import * as Icon from 'react-feather';
import BaseModal from './baseModal';
import { formatDateToFull, capitalizeFirstLetter } from '../../../../core/utils/utils';
import moment from 'moment';

const ShowDetailReservationHistoryModal: React.FC<any> = ({ selectedReservationData }) => {
    const [show, setShow] = useState<boolean>(false);
    const [reservationData, setReservationData] = useState<any>();

    useEffect(() => {
        if (selectedReservationData) {
            setReservationData(selectedReservationData);
            setShow(true);
        }
    }, [selectedReservationData]);

    const handleClose = () => {
        setShow(false);
    };

    return (
        <BaseModal
            show={show || false}
            title="Detalle de Reserva"
            onClose={handleClose}
            showButtons={false}
        >
            <div className="modal-body pt-0">
                <div className="text-center col-md-12 m-auto">
                    <Icon.CheckCircle size={45} color='#28a745' className="text-success fs-1" />
                    <div className="mt-4">
                        <h4>{reservationData?.customerName}</h4>
                        {reservationData?.classDate && (
                            <table className="table table-bordered mt-2">
                                <tbody>
                                    <tr>
                                        <th>Fecha de Clase</th>
                                        <td>{capitalizeFirstLetter(formatDateToFull(reservationData.classDate))}</td>
                                    </tr>
                                    <tr>
                                        <th>Hora de Clase</th>
                                        <td>{
                                      reservationData.classHour && (
                                        `${moment(reservationData.classHour.split(' - ')[0], 'HH:mm').format('hh:mm A')} - ${moment(reservationData.classHour.split(' - ')[1], 'HH:mm').format('hh:mm A')}`
                                      )
                                    }</td>
                                    </tr>
                                    <tr>
                                        <th>Nombre de Clase</th>
                                        <td>{reservationData.className}</td>
                                    </tr>
                                    <tr>
                                        <th>Entrenador</th>
                                        <td>{reservationData.trainerName}</td>
                                    </tr>
                                    <tr>
                                        <th>Asistió</th>
                                        <td>{reservationData.attended ? 'Sí' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th>Cancelado</th>
                                        <td>{reservationData.cancel ? 'Sí' : 'No'}</td>
                                    </tr>
                                    {reservationData.cancel && (
                                        <tr>
                                            <th>Motivo de Cancelación</th>
                                            <td>{reservationData.reason || 'No especificado'}</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <th>Lista de Espera</th>
                                        <td>{reservationData.waitlist ? 'Sí' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th>Fecha de Reserva</th>
                                        <td>{reservationData?.registrationDate && capitalizeFirstLetter(formatDateToFull(reservationData.registrationDate))}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <div className="d-flex gap-2 justify-content-center mt-4">
                    <button
                        type="button"
                        className="btn w-sm btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={handleClose}
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </BaseModal>
    );
}

export default ShowDetailReservationHistoryModal;